function bindPickupListener() {
  const select = document.querySelector('#cart-pickup-location');
  const wrapper = document.querySelector('#pickup-location-wrapper');
  const radios = document.querySelectorAll('input[name="delivery_type"]');

  // Bind location dropdown — keeping the same exact pickup_location logic
  if (select && !select.dataset.bound) {
    select.dataset.bound = "true";

    select.addEventListener("change", function () {
      const value = this.value;
      console.log("Saving pickup:", value);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { pickup_location: value } })
      })
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => console.log("Updated attributes:", cart.attributes))
      .catch(console.error);
    });
  }

  // Bind delivery type radios
  radios.forEach(function (radio) {
    if (radio.dataset.bound) return;

    radio.dataset.bound = "true";

    radio.addEventListener("change", function () {
      if (!this.checked) return;

      const isPickup = this.value === "pickup";

      if (wrapper) {
        wrapper.style.display = isPickup ? "block" : "none";
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { delivery_type: this.value } })
      })
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => console.log("Updated delivery type:", cart.attributes))
      .catch(console.error);
    });
  });
}

// Attach on DOM load
document.addEventListener("DOMContentLoaded", bindPickupListener);

// Attach whenever Shopify rerenders the cart
document.addEventListener("cart:updated", bindPickupListener);

// Attach even after dynamic theme render
const observer = new MutationObserver(() => bindPickupListener());
observer.observe(document.body, { childList: true, subtree: true });